
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prior-auth-tool",
      function () {
        return require("private-next-pages/prior-auth-tool.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prior-auth-tool"])
      });
    }
  